import { RouteState, useRoute } from "eddev/routing"
import { createContext, useContext, useMemo } from "react"

export type Theme = {
  header: "light" | "dark"
  page: "light" | "dark"
}

const SiteThemeContext = createContext<Theme>({
  header: "light",
  page: "light",
})

type Props = {
  route: RouteState
  children: React.ReactNode
}

export function SiteTheme(props: Props) {
  const theme = useMemo(() => getThemeFromRoute(props.route), [props.route.pathname])
  const route = useRoute()
  const isTFF = route.pathname.startsWith("/tff")
  return (
    <SiteThemeContext.Provider value={theme}>
      <div
        data-is-tff={isTFF}
        style={{
          "--color-orange": isTFF ? "var(--color-teal)" : undefined,
        }}
      >
        {props.children}
      </div>
    </SiteThemeContext.Provider>
  )
}

export function useSiteTheme() {
  return useContext(SiteThemeContext)
}

export const getThemeFromRoute = (route: RouteState): Theme => {
  if (route.view === "template-home" || route.view === "archive-strand" || route.view === "template-film-finder") {
    return {
      header: "dark",
      page: "dark",
    }
  } else if (route.view === "program" && route.pathname === "/program") {
    return {
      header: "dark",
      page: "dark",
    }
  } else if (route.pathname.startsWith("/program")) {
    return {
      header: "dark",
      page: "light",
    }
  }
  return {
    header: "light",
    page: "light",
  }
}
